import { Form } from '@sitecore-jss/sitecore-jss-react-forms';
import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { sitecoreApiHost, sitecoreApiKey } from '../../temp/config';
import { createDefaultFieldFactory } from '@sitecore-jss/sitecore-jss-react-forms';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import styled from 'styled-components';

const buttonItemId = '{7CE25CAB-EF3A-4F73-AB13-D33BDC1E4EE2}';
const recaptchaItemId = '{E383BDE2-BC88-4278-83EF-832A15C9E94A}';
const OuterColumnContainerItemId = '{1EBD96B9-FDCC-4CE2-AB08-2DD73B5B0D01}';
const ColumnSectionItemId = '{7A46100E-B6AB-48C4-9CD5-945AFD9194EA}';

const myCustomFormFactory = createDefaultFieldFactory();

myCustomFormFactory.setComponent(buttonItemId, (props) => {
    async function onButtonClick(e) {
        var wrapperDiv = document.getElementById(props?.tracker?._formId);

        if (wrapperDiv) {
            // Get the form inside the div (assuming there's only one form)
            var form = wrapperDiv.querySelector('form');

            // Check if the form exists
            if (form) {
                if (form.getElementsByClassName('recaptcha-hidden').length > 0) {
                    if (!!form.getElementsByClassName('recaptcha-hidden')[0].value) {
                        return true;
                    } else {
                        e.preventDefault();
                        alert('Recaptcha is required.');
                        return false;
                    }
                }
            }
        }
    };

    return (
        <>
            <button
                style={{ position: 'relative' }}
                type="submit"
                value={props?.field?.model?.title}
                name={props?.field?.buttonField?.name}
                id={props?.field?.buttonField?.id}
                onClick={onButtonClick}
            >
                {props?.field?.model?.title}
            </button>
        </>
    );
});

myCustomFormFactory.setComponent(recaptchaItemId, (props) => {
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [isVerified, setIsVerified] = useState(false);

    const inputName = props?.field?.valueField?.name?.replace('Value', 'CaptchaValue');

    const onRecaptchaChange = (token) => {
        setRecaptchaToken(token);
        setIsVerified(!!token);

        // This is what allows the reCaptcha token to be sent with the Form Post request
        props.onChange(inputName, token, !!token);
    };

    return (
        <>
            <input
                type="hidden"
                value={recaptchaToken}
                className="recaptcha-hidden"
            ></input>
            <div style={{ marginTop: '20px' }}>
                <ReCAPTCHA
                    sitekey={props?.field?.model?.captchaPublicKey}
                    onChange={onRecaptchaChange}
                    onExpired={() => {
                        setIsVerified(false);
                        setRecaptchaToken('');
                    }} // Handle expired reCAPTCHA
                />
            </div>
        </>
    );
});

const OuterColumnContainer = ({
    field,
    fieldFactory,
}) => <div data-sc-field-key={field.model.conditionSettings.fieldKey} className={field.model.cssClass + ' container clearfix'}>
        {field.fields.map(fieldFactory)}
    </div>

const ColumnSection = ({
    field,
    fieldFactory,
}) => <div data-sc-field-key={field.model.conditionSettings.fieldKey} className={field.model.cssClass + ' ' + field.model.sectionWidth}>
        {field.fields.map(fieldFactory)}
    </div>

myCustomFormFactory.setComponent(OuterColumnContainerItemId, OuterColumnContainer);
myCustomFormFactory.setComponent(ColumnSectionItemId, ColumnSection);

const GenericForm = (props) => {
const { fields, history } = props;

  // To allow for form submissions on local Headless JSS site set: sitecoreApiHost={''}
  return (
    <>
      <div className="container" id={fields?.formItemId?.value}>
        <StyledForm>
          <Form
            form={fields}
            sitecoreApiHost={sitecoreApiHost}
            sitecoreApiKey={sitecoreApiKey}
            fieldFactory={myCustomFormFactory}
            onRedirect={(url) => history.push(url)}
          />
        </StyledForm>
      </div>
    </>
  );
};

const StyledForm = styled.div`
  .lbl {
    position: relative !important;
    height: 100% !important;
    width: 100% !important;
    text-align: left !important;
    margin-left: 2px !important;
    font-weight: 400 !important;
    font-size: 14px !important;
  }
`;

export default withRouter(GenericForm);
